import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainers(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_process/${agro_exporter_id}/fetch_containers/${agro_exporter_process_id}`
    );
  },
  fetchOrgInvoices(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_process/${agro_exporter_id}/fetch_org_invoices/${agro_exporter_process_id}`
    );
  },
  downloadRepXlsx(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_process/${agro_exporter_id}/download_rep_xlsx/${agro_exporter_process_id}`,
      { responseType: "blob" }
    );
  },
  downloadFairtradeReport(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_outcomes/show_process/${agro_exporter_id}/download_rep_fairtrade_xlsx/${agro_exporter_process_id}`,
      { responseType: "blob" }
    );
  },
  // downloadRepDetailedXlsx(agro_exporter_id, agro_exporter_process_id) {
  //   return RequesterV1.get(
  //     `agro_exporter/finances/container_outcomes/show_process/${agro_exporter_id}/download_rep_detailed_xlsx/${agro_exporter_process_id}`,
  //     { responseType: "blob" }
  //   );
  // }
};
